import React from 'react';

const ItemsTable = ({ items, isAdmin, onEdit, onView, onDuplicate }) => {
  return (
    <div className="items-table-container">
      <table className="items-table">
        <thead>
          <tr>
            <th>Part #</th>
            <th>Name</th>
            <th>Category</th>
            <th>Type</th>
            <th>Weight/Pc</th>
            <th>Qty/Case</th>
            <th>Case Weight</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="part-number">{item.part_number}</td>
              <td className="item-name">
                <span
                  className="clickable-link"
                  onClick={() => isAdmin ? onEdit(item) : onView(item)}
                >
                  {item.name}
                </span>
              </td>
              <td>
                {item.category_name && (
                  <span className="category-badge">
                    {item.category_name}
                  </span>
                )}
              </td>
              <td>{item.raw_baked}</td>
              <td>{item.weight_per_piece ? `${item.weight_per_piece}g` : '-'}</td>
              <td>{item.qty_per_case || '-'}</td>
              <td>{item.case_weight ? `${item.case_weight}kg` : '-'}</td>
              <td className="actions-cell">
                {isAdmin ? (
                  <>
                    <button className="action-btn edit" onClick={() => onEdit(item)}>
                      Edit
                    </button>
                    <button className="action-btn duplicate" onClick={() => onDuplicate(item)}>
                      Duplicate
                    </button>
                  </>
                ) : (
                  <button className="action-btn view" onClick={() => onView(item)}>
                    View
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ItemsTable;
